function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Details Page
 * 
 */
import * as React from 'react';
import AlreadyPaid from '../../components/already-paid/AlreadyPaid';
import AutoFill from '../../components/autofill/AutoFill';
import ErrorApp from '../../components/error-app/ErrorApp';
import ExpiredModal from '../../components/expired-modal/ExpiredModal';
import PersonalDetails from './personal-details/PersonalDetails';
import LicenceDetails from './licence-details/LicenceDetails';
import Progress from '../../components/progress/Progress';
import Footer from './footer/Footer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { application, acceptCookies, deleteAll, locality } from '../../actions';
import { isOrderExpired } from '../../functions/orderExpiration';
import moment from 'moment';
import './Details.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Details extends React.Component {
  constructor(props) {
    super(props);
    /**
     * Check if the order has expired (24 hours since creation)
     */
    _defineProperty(this, "checkExpiration", () => {
      const {
        application
      } = this.props;
      if (application?.created_at && isOrderExpired(application.created_at)) {
        this.setState({
          showExpiredModal: true
        });
      }
    });
    /**
     * For persisted data without URL params:
     * If expired, clear stale data and redirect to start fresh
     */
    _defineProperty(this, "checkExpirationOrClear", () => {
      const {
        application,
        deleteAll
      } = this.props;
      if (application?.created_at && isOrderExpired(application.created_at)) {
        // Stale persisted data - clear and redirect to start fresh
        deleteAll();
        window.location.href = application.referrer || '/';
      }
    });
    /**
     * Handle expired modal action - clear state and redirect to referrer
     */
    _defineProperty(this, "handleExpiredAction", () => {
      const {
        application,
        deleteAll
      } = this.props;
      deleteAll();
      window.location.href = application.referrer || '/';
    });
    /**
     * load App data from URL Vars
     * If the homepage form is on a different domain, we pass the params via URL vars
     * So we need to extract them here.
     *
     * Delete data in store if we are passed vars in the URL
     */
    _defineProperty(this, "loadData", () => {
      const {
        deleteAll,
        location,
        setAcceptCookies,
        setAcceptTerms,
        setApplication,
        setLocality,
        application
      } = this.props;
      const {
        search
      } = location;
      const {
        id: appId
      } = application;
      if (search === '') {
        return null;
      }
      const params = new URLSearchParams(search);
      const orderId = params.get('id');
      const clubId = params.get('club_id');
      const clubName = params.get('club_name');
      const clubAbbr = params.get('club_abbreviation');
      const created_at = params.get('created_at');
      const cookiesValue = params.get('cookies');
      const localityUrlVar = params.get('home-form_locality');
      const termsValue = params.get('terms');
      const token = params.get('token');
      const referrer = params.get('referrer');
      const app = {
        club: {
          id: clubId ? clubId : '-1',
          name: clubName ? clubName : '',
          abbreviation: clubAbbr ? clubAbbr : ''
        },
        created_at: created_at ? created_at : moment().format('U'),
        id: orderId ? orderId : '-1',
        submission_token: token ? token : '',
        referrer: referrer ? referrer : ''
      };
      const cookies = cookiesValue === 'true' ? true : false;
      const locality = localityUrlVar !== null ? localityUrlVar : '';
      const terms = termsValue === 'true' ? true : false;

      // If we have fresh URL params from HomeForm, those take precedence over
      // any stale persisted data. Clear stale data but continue loading.
      if (orderId) {
        // Clear stale data if there's a conflict (previous submission completed,
        // or mismatched application ID from a different session)
        if (this.props.transaction.success || appId && parseInt(appId, 10) !== parseInt(orderId, 10)) {
          deleteAll();
        }
        // Continue below to load fresh URL params - don't redirect
      } else {
        // No URL params - we're relying on persisted state
        // Check for stale/invalid persisted data
        if (this.props.transaction.success) {
          deleteAll();
          window.location.href = '/';
          return null;
        }
      }

      // Load application data from URL params.
      if (orderId) {
        setTimeout(() => {
          setApplication(app);
          setAcceptCookies(cookies);
          setAcceptTerms(terms);
          setLocality(locality);
          window.history.pushState({}, document.title, location.pathname);
        }, 500);
      }
      return true;
    });
    this.state = {
      showExpiredModal: false
    };
    const {
      jest
    } = props;

    // scroll to top
    if (!jest) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  componentDidMount() {
    const hasUrlParams = this.loadData();
    if (hasUrlParams) {
      // Check expiration after data loads from URL params
      // Allow enough time for Redux state to propagate (500ms for setApplication + 500ms buffer)
      setTimeout(() => {
        this.checkExpiration();
      }, 1000);
    } else {
      // No URL params - wait for redux-persist to fully sync, then check
      // This handles the case where HomeForm just set fresh data but redirect happened before sync
      setTimeout(() => {
        this.checkExpirationOrClear();
      }, 500);
    }
  }
  render() {
    const {
      application,
      bugsnagClient,
      transaction
    } = this.props;
    const {
      showExpiredModal
    } = this.state;
    const {
      id,
      submission_token
    } = application;
    switch (true) {
      case showExpiredModal:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx(ExpiredModal, {
            show: true,
            onAction: this.handleExpiredAction
          })]
        });
      case !id || !submission_token:
        return /*#__PURE__*/_jsx(ErrorApp, {
          bugsnagClient: bugsnagClient
        });
      case transaction.success:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx("section", {
            className: "content-container",
            children: /*#__PURE__*/_jsx("div", {
              className: "Details",
              children: /*#__PURE__*/_jsx(AlreadyPaid, {})
            })
          })]
        });
      default:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx("section", {
            className: "content-container",
            children: /*#__PURE__*/_jsx("div", {
              className: "Details",
              children: /*#__PURE__*/_jsxs("form", {
                children: [/*#__PURE__*/_jsx(AutoFill, {
                  bugsnagClient: bugsnagClient
                }), /*#__PURE__*/_jsx(PersonalDetails, {
                  bugsnagClient: bugsnagClient
                }), /*#__PURE__*/_jsx(LicenceDetails, {
                  bugsnagClient: bugsnagClient
                }), /*#__PURE__*/_jsx(Footer, {
                  bugsnagClient: bugsnagClient
                })]
              })
            })
          })]
        });
    }
  }
}
_defineProperty(Details, "defaultProps", {
  application: {
    id: '12312',
    submission_token: '234gn82h5'
  },
  cookies: false,
  deleteAll: () => null,
  jest: false,
  persisted: false,
  terms: false,
  locality: {
    club: '',
    value: ''
  },
  setAcceptTerms: () => null,
  setAcceptCookies: () => null,
  setApplication: () => null,
  setLocality: () => null,
  transaction: {
    success: false
  }
});
const mapStateToProps = ({
  application,
  cookies,
  locality,
  terms,
  transaction
}) => {
  return {
    application,
    cookies,
    locality,
    terms,
    transaction
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAll: () => {
      dispatch(deleteAll());
    },
    setApplication: value => {
      dispatch(application(value));
    },
    setAcceptCookies: value => {
      dispatch(acceptCookies(value));
    },
    setLocality: value => {
      dispatch(locality(value));
    }
  };
};
const VisibleDetails = connect(mapStateToProps, mapDispatchToProps)(Details);
export default withRouter(VisibleDetails);